import { BCMSRecord, useGlobalController } from "@bcm-dev/bcms-vite";
import DepositACheckPage, { getDefaultPageData } from "components/pages/DepositACheckPage";
import Classes, { Account } from "model";

export default function CaptureMabiDepositsAccountSelected(props) {
    const globalController = useGlobalController();
    BCMSRecord.globalControllerFor(Classes, globalController);
    const account = Account.getDefaultBrandedAccountByType("checking");
    const data = getDefaultPageData();
    data.deposit.account = Account.initByID(account.id);

    return <DepositACheckPage data={ data } />
}